<template>
  <div class="not-found-page">
    <img
      src="/img/pandas/search.png"
      alt="Biku, the Off The Couch mascot, searching with a magnifying glass"
      width="260"
      height="260"
    />
    <h1>404</h1>
    <p>Biku looked everywhere, but this page doesn't exist.</p>
    <router-link to="/" class="btn-cta-primary">Back to the homepage</router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
};
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/marketing-tokens';

.not-found-page {
  min-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 110px 1.5rem 80px;

  img {
    max-width: 260px;
    height: auto;
  }

  h1 {
    color: white;
    font-size: 3.5rem;
    font-weight: 700;
    margin: 0.5rem 0 0.25rem;
  }

  p {
    color: $muted;
    font-size: 1.05rem;
    margin-bottom: 2rem;
  }
}
</style>
